"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWindow = exports.useDocument = exports.WindowProvider = exports.WindowContext = void 0;
require("./version");
var react_window_provider_1 = require("@fluentui/react-window-provider");
Object.defineProperty(exports, "WindowContext", { enumerable: true, get: function () { return react_window_provider_1.WindowContext; } });
Object.defineProperty(exports, "WindowProvider", { enumerable: true, get: function () { return react_window_provider_1.WindowProvider; } });
Object.defineProperty(exports, "useDocument", { enumerable: true, get: function () { return react_window_provider_1.useDocument; } });
Object.defineProperty(exports, "useWindow", { enumerable: true, get: function () { return react_window_provider_1.useWindow; } });
//# sourceMappingURL=WindowProvider.js.map